import { LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

interface TefConfigurationGridCardProps {
  Icon: LucideIcon;
  label: string;
  provider: string;
}

const TefConfigurationGridCard = ({ Icon, label, provider }: TefConfigurationGridCardProps) => {
  return (
    <Link
      to={provider}
      className="bg-white-200 hover:bg-white-300/20 transition-colors cursor-pointer p-4 flex flex-col gap-y-8 rounded-lg shadow-xl"
      data-testid={`tef_provider_link_${provider}`}
    >
      <Icon strokeWidth={1} size={46} />

      <p className="text-[18px]">
        {label}
      </p>
    </Link>
  );
}

export default TefConfigurationGridCard;
